/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { CSSBall } from "src/components/UI/Loading/Spinners/SpinnerBall/CSSBall";
import { SpinnerWrapper } from "src/components/UI/Loading/Spinners/SpinnerBall/SpinnerWrapper";

export const FullScreenSpinner = () => (
  /**
   * A full screen loading spinner. Highly nested.
   *
   * From top to bottom the spinner components are:
   * 1. BigSpinnerWrapper: occupies viewport and centers the loader
   * 2. SpinnerWrapper: Flexible wrapper for all loading spinners. Sets spinner color and scale.
   * 3. SpinnerBall: Contains the animation logic for the spinner. Renders the SpinnerBallSVG.
   * 4. SpinnerBallSVG: An inlined SVG of the spinner shape.
   *
   */

  <BigSpinnerWrapper>
    <SpinnerWrapper>
      <CSSBall />
    </SpinnerWrapper>
  </BigSpinnerWrapper>
);
const BigSpinnerWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
